import React from "react";

export default function AWS_Cloudfront() {
  return (
    <div>
      <h1>What is AWS Cloudfront</h1>
      <p>
        Route: <code>/aws/cloudfront</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
